export enum ActionEnum {
  ADD = 'add',
  UPDATE = 'update',
}
